import React, { Component } from "react";
import {
  Header,
  Form,
  Message,
  Segment
} from "semantic-ui-react";

import * as CONSTANTS from "../assets/Constants";
import * as LINKS from "../assets/Links";

class AddProjectForm extends Component {
  state = {
    memberId: "",
    projectName: "",
    projectDescription: "",
    projectTags: "",
    projectCompletionYear: "",
    error: false,
    success: false,
    errorMsg: "",
    batchesToBeRendered: [],
    membersToBeRendered: [],
    membersToBeAdded: []
  };

  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    let batchesList = CONSTANTS.batchesList;
    var batchesLocal = [];
    batchesList.forEach(function(year) {
      batchesLocal.push({
        key: year,
        text: year,
        value: year
      });
    });
    this.setState({ batchesToBeRendered: batchesLocal });
  }

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  };

  handleSubmit() {
    const {
      projectName,
      projectDescription,
      projectTags,
      projectCompletionYear
    } = this.state;

    if (projectCompletionYear.length !== 4 || isNaN(projectCompletionYear)) {
      this.setState({ errorMsg: "Year should be of 4 numbers!" });
      this.setState({ error: true });
      return;
    }

    if (projectName.length >= 120) {
      this.setState({ errorMsg: "Project Name should be of 100 characters" });
      this.setState({ error: true });
      return;
    }

    // console.log(this.state);

    let membersToBeAdded = this.state.membersToBeAdded;
    membersToBeAdded.push(parseInt(localStorage.getItem("id")));
    membersToBeAdded = Array.from(new Set(membersToBeAdded));

    // console.log(membersToBeAdded);
    fetch(LINKS.SERVER_BASE_URL + LINKS.SERVER_ROUTES.createProject, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: localStorage.getItem("dat")
      },
      body: JSON.stringify({
        project: {
          project_name: projectName,
          description: projectDescription,
          tags: projectTags,
          completion_year: projectCompletionYear
        },
        project_member_map: {
          members: membersToBeAdded
        }
      })
    })
      .then(resp => resp.json())
      .then(data => {
        if (!data["success"]) {
          console.log(data);
          this.setState({ error: true, errorMsg: data.error });
        } else {
          console.log(data);
          this.setState({ success: true });
          console.log("Updated!");
        }
      });
  }

  handleSelectedBatch = (event, selected) => {
    // console.log(selected.value)
    let year = selected.value[selected.value.length - 1];
    // console.log(year);
    // eslint-disable-next-line eqeqeq
    if (year == "" || year === undefined) {
      this.setState({ membersToBeRendered: [] });
      return;
    }
    fetch(LINKS.SERVER_BASE_URL + LINKS.SERVER_ROUTES.teamDetailsByYear + year)
      .then(response => response.json())
      .then(data => {
        var membersLocal = this.state.membersToBeRendered;
        Object.keys(data).forEach(function(key) {
          // console.log(data[key]['name'])
          let name = data[key]["name"];
          let memberId = data[key]["id"];
          membersLocal.push({
            key: name,
            text: name,
            value: memberId
          });
        });
        this.setState({ membersToBeRendered: membersLocal });
      })
      .catch(error => {
        console.log(error);
      });
  };

  handleSelectedMembers = (event, selected) => {
    console.log(selected.value);
    this.setState({ membersToBeAdded: selected.value });
  };

  render() {
    const {
      projectName,
      projectDescription,
      projectTags,
      projectCompletionYear
    } = this.state;

    return (
      <Segment style={{ marginBottom: "3em", marginTop: "3em" }} inverted>
        <Header as="h2" textAlign="center">
          Add Project
        </Header>
        <Form
          size="medium"
          onSubmit={this.handleSubmit}
          error={this.state.error}
          inverted
        >
          <Form.Input
            fluid
            name="projectName"
            label="Project Name"
            icon="file text"
            iconPosition="left"
            placeholder="Name of your Project"
            value={projectName}
            onChange={this.handleChange}
            required={true}
          />
          <Form.TextArea
            // fluid
            name="projectDescription"
            label="Project Description"
            // icon="file text outline"
            // iconPosition="left"
            placeholder="Write about your Project"
            value={projectDescription}
            onChange={this.handleChange}
            required={true}
          />
          <Form.TextArea
            fluid
            name="projectTags"
            label="Tags associated with your Project (seperate by comma)"
            icon="tags"
            iconPosition="left"
            placeholder="Tags associated with your Project, seperate by comma"
            value={projectTags}
            onChange={this.handleChange}
            required={true}
          />
          <Form.Input
            fluid
            name="projectCompletionYear"
            label="Year of Completion"
            icon="calendar"
            iconPosition="left"
            placeholder="yyyy"
            value={projectCompletionYear}
            onChange={this.handleChange}
            required={true}
          />
          <Form.Dropdown
            fluid
            label="Multi-select the batch your collaborator belongs to"
            multiple
            options={this.state.batchesToBeRendered}
            selection
            placeholder="Choose batches"
            onChange={this.handleSelectedBatch}
          />
          <Form.Dropdown
            fluid
            label="Multi-select the collaborators (You don't have to select yourself 😅)"
            options={this.state.membersToBeRendered}
            selection
            placeholder="Choose the members"
            multiple
            search
            onChange={this.handleSelectedMembers}
          />
          <Message error={!this.state.error}>
            <Message.Content>
              {this.state.errorMsg + ", Reload and Retry Again..."}
            </Message.Content>
          </Message>
          <Message positive success={!this.state.success}>
            <Message.Content>
                Added!
            </Message.Content>
        </Message>
          <Form.Button
            color="grey"
            size="large"
            type="submit"
            disabled={this.state.error || this.state.success}
          >
            Add
          </Form.Button>
        </Form>
      </Segment>
    );
  }
}

export default AddProjectForm;
